import Alarm from "./Alarm";

export default class AlarmZone extends Alarm {
	constructor(data) {
		super(data);
		this.cartodb_id = data.cartodb_id || 0;
		this.type_alarm = data.type_alarm || 1;
	}
}
